import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 17.76 22.14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2.46 5.62c.41 0 .74-.33.74-.74 0-1.84 1.6-3.39 3.49-3.39s3.39 1.55 3.39 3.39c0 .41.33.74.74.74s.74-.33.74-.74C11.56 2.19 9.37 0 6.69 0S1.72 2.23 1.72 4.88c0 .41.33.74.74.74"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.54 9.55c-.35 0-.69.1-.99.25-.37-.72-1.12-1.24-1.97-1.24-.35 0-.69.1-.99.25-.37-.72-1.12-1.24-1.97-1.24-.26 0-.5.06-.74.14V4.86c0-1.19-1.02-2.21-2.21-2.21h-.09c-1.04.13-2.12.94-2.12 2.21v6.88l-.61-.61c-.88-.88-2.33-.88-3.21 0-.73.73-.89 1.9-.29 2.8l3.44 5.21c1.22 1.89 3.33 2.99 5.54 2.99h1.77c3.65 0 6.64-2.99 6.64-6.64v-3.74c0-1.19-1.02-2.21-2.21-2.21Zm.74 5.95c0 2.84-2.33 5.17-5.17 5.17H9.34c-1.72 0-3.36-.86-4.3-2.32l-3.45-5.22a.76.76 0 0 1 .1-.94c.3-.3.82-.3 1.12 0l1.87 1.87c.21.21.53.27.8.16.28-.11.46-.38.46-.68V4.87c0-.3.28-.65.78-.74.36.03.7.37.7.74v6.69c0 .41.33.74.74.74s.74-.33.74-.74V9.79c0-.38.36-.74.74-.74s.74.36.74.74v1.77c0 .41.33.74.74.74s.74-.33.74-.74v-.79c0-.38.36-.74.74-.74s.74.36.74.74v1.77c0 .41.33.74.74.74s.74-.33.74-.74v-.79c0-.38.36-.74.74-.74s.74.36.74.74v3.74Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }